import { render } from "./RoundGroupMenu.vue?vue&type=template&id=4668f348&scoped=true"
import script from "./RoundGroupMenu.vue?vue&type=script&lang=js"
export * from "./RoundGroupMenu.vue?vue&type=script&lang=js"

import "./RoundGroupMenu.vue?vue&type=style&index=0&id=4668f348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4668f348"]])

export default __exports__